module.exports = __webpack_public_path__ + "static/media/art37.c0bf8d5a.jpg";